import React from 'react';
import './Terms.css';

function TakedownPolicy() {
  return (
    <div className="terms">
      <div className="terms-container">
        <h1>Legal Notice</h1>

        <p>
          <strong>HYNT SOLUTIONS PRIVATE LIMITED</strong> is a company incorporated under the Companies Act, 2013,
          having its registered office at 1201 A Wing New Light CHS, TPS IV South Avenue Khar, Khar Colony, Mumbai,
          Mumbai- 400052, Maharashtra and Corporate Identification Number (CIN): U58200MH2026PTC465233.
          <br /><br />
          This document is an electronic record in terms of the Information Technology Act, 2000 and the rules made
          thereunder, and the amended provisions pertaining to electronic records in various statutes as amended by the
          Information Technology Act, 2000. This electronic record is generated by a computer system and does not
          require any physical or digital signatures.
          <br /><br />
          This document is published in accordance with the provisions of Rule 3(1) of the Information Technology
          (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, which mandate the publication of the
          rules and regulations, privacy policy, and Terms of Use for access or usage of the HYNT SOLUTIONS PRIVATE
          LIMITED Platform — available at <a href="http://www.hynt.co.in/">http://www.hynt.co.in/</a>
          <br /><br />

          <section>
            <strong>9. TAKEDOWN POLICY</strong>

            <div className="section">
              <strong>a. Purpose and Scope</strong>
              <p>
                HYNT SOLUTIONS PRIVATE LIMITED (<strong>"HYNT", "we", "us", or "our"</strong>) respects the intellectual
                property rights, privacy, and reputation of all individuals and entities. This Takedown Policy
                (<strong>"Takedown"</strong>) outlines the process through which individuals, rights holders, or authorized
                representatives may report and request the removal of content that allegedly violates intellectual property
                rights, privacy rights, or any applicable law, and the manner in which such complaints will be addressed
                by HYNT.
              </p>
            </div>

            <div className="section">
              <strong>b. Grounds for Takedown Requests</strong>
              <p>
                You may submit a takedown request if you believe that any content hosted, published, or displayed on the
                Platform:
              </p>
              <ol type="i">
                <li>infringes any copyright, trademark, patent, or other intellectual property right;</li>
                <li>violates your privacy or publicity rights;</li>
                <li>is defamatory, obscene, pornographic, harmful to minors, or otherwise unlawful;</li>
                <li>violates these Terms, the Privacy Policy, or any applicable law; or</li>
                <li>constitutes impersonation, harassment, hate speech, or any other form of prohibited content.</li>
              </ol>
            </div>

            <div className="section">
              <strong>c. Procedure for Submitting a Takedown Request</strong>
              <p>
                To enable us to process your request efficiently, please submit a written notice to the Grievance
                Redressal Officer at <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a> or by registered
                post to our registered office, containing the following details:
              </p>
              <ol type="i">
                <li>Your full name, postal address, and valid contact details (email and phone number);</li>
                <li>
                  A clear description of the content or material you wish to be removed, including the exact URL or
                  location on the Platform;
                </li>
                <li>
                  A statement explaining the nature of your complaint and the legal right allegedly infringed or
                  violated;
                </li>
                <li>
                  If the claim pertains to intellectual property, documentary evidence establishing your ownership of
                  such rights (e.g., registration certificate, license, or authorization);
                </li>
                <li>
                  A statement that you have a good faith belief that the disputed use of the material is not authorized
                  by you, your agent, or the law; and
                </li>
                <li>
                  A statement made under penalty of perjury that the information in your notice is true and that you
                  are authorized to act on behalf of the rights owner or affected party.
                </li>
              </ol>
              <p>
                The notice must be signed physically or electronically by the complainant or an authorized
                representative.
              </p>
            </div>

            <div className="section">
              <strong>d. Action Upon Receipt of a Valid Complaint</strong>
              <p>Upon receipt of a valid takedown request, HYNT shall:</p>
              <ol type="i">
                <li>Review the complaint to verify its completeness and authenticity;</li>
                <li>
                  Take down, disable access to, or restrict visibility of the allegedly infringing or unlawful content
                  on a temporary basis, pending further review; and
                </li>
                <li>
                  Notify the user who uploaded the content, providing them an opportunity to respond or submit a
                  counter-notification within seven (7) business days of receiving such notice.
                </li>
              </ol>
            </div>

            <div className="section">
              <strong>e. Counter-Notification Procedure</strong>
              <p>
                A user who believes that their content was removed or disabled in error may send a
                counter-notification to <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a> within seven
                (7) business days, including:
              </p>
              <ol type="i">
                <li>Their full name, postal address, and contact details;</li>
                <li>
                  Identification of the content that was removed or disabled and its location before removal;
                </li>
                <li>
                  A statement explaining why the content does not infringe any rights or violate any law; and
                </li>
                <li>A declaration under penalty of perjury that the information provided is accurate.</li>
              </ol>
              <p>
                HYNT may reinstate or continue to restrict the content based on the outcome of its assessment of the
                counter-notification and any applicable legal requirements.
              </p>
            </div>

            <div className="section">
              <strong>f. Repeat Infringement Policy</strong>
              <p>
                In accordance with applicable laws and these Terms, HYNT reserves the right to suspend or terminate the
                accounts of users who are found to be repeat infringers or who repeatedly upload content that violates
                third-party rights or applicable law.
              </p>
            </div>

            <div className="section">
              <strong>g. No Obligation or Admission</strong>
              <p>
                HYNT reserves the right to remove or disable access to any content at its sole discretion, without prior
                notice, and without admitting liability. HYNT also reserves the right to reject or disregard any
                incomplete, misleading, or unverifiable takedown requests. Nothing in this Takedown Policy shall be
                construed as an admission of liability or wrongdoing by HYNT.
              </p>
            </div>

            <div className="section">
              <strong>h. Contact Information</strong>
              <p>All takedown requests and counter-notifications should be addressed to:</p>
              <p>
                Grievance Redressal Officer: Harsh Shah
                <br />
                Designation: COO
                <br />
                Email: <a href="mailto:grievances@hynt.co.in">grievances@hynt.co.in</a>
                <br />
                Address: 1201 A Wing New Light CHS, TPS IV South Avenue Khar, Khar Colony, Mumbai, Mumbai- 400052,
                Maharashtra
              </p>
            </div>

          </section>

        </p>
      </div>
    </div>
  );
}

export default TakedownPolicy;